import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const Ctx = createContext({ features: {}, brand: {}, reload: () => {} });
export const usePublicSettings = () => useContext(Ctx);

export function PublicSettingsProvider({ children }) {
  const [data, setData] = useState({ features: {}, brand: {} });
  const reload = () =>
    api.get("/public-settings")
      .then((r) => setData({ features: r.data.features || {}, brand: r.data }))
      .catch(() => {});
  useEffect(() => { reload(); }, []);
  return <Ctx.Provider value={{ ...data, reload }}>{children}</Ctx.Provider>;
}
